import { DUMMY_LOGGER } from 'UTILS/constants';

const PLAY_DELAY = 500; // ms

const play = async({
  audioElement,
  audioElementId,
  deviceId,
  volume = 1,
  onError = () => {},
  onPlayed = () => {},
  logger = DUMMY_LOGGER,
  immediate = false,
}) => {
  let audioEl;
  if (typeof audioElementId === 'string') {
    audioEl = document.getElementById(audioElementId);
  } else {
    audioEl = audioElement;
  }
  if (typeof audioEl?.play !== 'function') {
    throw Error('invalid_audio_element');
  }
  const handlePlayed = () => {
    logger.log('SpeakersCheck - Played');
    audioEl.removeEventListener('ended', handlePlayed);
    onPlayed();
  };
  audioEl.addEventListener('ended', handlePlayed);

  const playSound = async({ quick } = {}) => {
    try {
      logger.log('SpeakersCheck - Play');
      if (typeof audioEl.setSinkId === 'function' && deviceId) {
        logger.log('SpeakersCheck - setSinkId', deviceId);
        await audioEl.setSinkId(deviceId);
      }
      audioEl.volume = volume;
      await audioEl.play();
      if (quick) {
        audioEl.pause();
        handlePlayed();
      }
    } catch (err) {
      if (err.name === 'NotAllowedError') {
        logger.warn('SpeakersCheck - NotAllowedError', err);
        onError('not_allowed');
        onPlayed();
        return;
      }
      logger.error('CAUGHT ERROR in SPEAKERS CHECK', err); // TODO: remove
      onError(); // TODO: Pass data according to reason of failure
      throw err;
    }
  };

  if (immediate) {
    await playSound({ quick: true });
  } else {
    setTimeout(async() => {
      await playSound();
    }
    , PLAY_DELAY);
  }
};

export default {
  play,
};
